module.exports = __webpack_public_path__ + "img/web_3_2x.35427dcb.png";